import React, { useState, useEffect } from "react";
import Layout from "components/structure/Layout";
import './ImportFarmer.css'; // Ensure you have appropriate styles
import ImportList from "../Common/ImportList";

const ImportFarmer = () => {
  return (
    <Layout title={"Import Farmer"}>
      <ImportList entityName="ImportFarmer" displayName="Import Farmer" />
    </Layout>
  );
};

export default ImportFarmer;
